/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "@app/axios/axiosIns";


export const getAllDesignations = createAsyncThunk(
  "designation/all",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/designation", { params });
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getDesignation = createAsyncThunk(
  "designation/get",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/designation/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const addDesignation = createAsyncThunk(
  "designation/add",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/admin/designation", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getFilterDesignation = createAsyncThunk(
  "designation/getFilter",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/designation/designationList", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateDesignation = createAsyncThunk(
  "designation/update",
  async ({ id, data }: { id: string | undefined; data: any }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/admin/designation/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteDesignation = createAsyncThunk(
  "designation/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/admin/designation/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);


interface DesignationState {
  isLoading: boolean;
  formLoader: boolean;
  designation: any;
  allDesignations: any[];
  error: any;
}

const initialState: DesignationState = {
  isLoading: false,
  formLoader: false,
  designation: null,
  allDesignations: [],
  error: null,
};

    
const designationSlice = createSlice({
  name: "designation",
  initialState,
  reducers: {
    resetDesignationState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDesignations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllDesignations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allDesignations = action.payload?.data || [];
      })
      .addCase(getAllDesignations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(getDesignation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDesignation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.designation = action.payload?.data;
      })
      .addCase(getDesignation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(addDesignation.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(addDesignation.fulfilled, (state, action) => {
        state.formLoader = false;
        state.designation = action.payload?.data;
      })
      .addCase(addDesignation.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.payload;
      })

      .addCase(updateDesignation.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(updateDesignation.fulfilled, (state, action) => {
        state.formLoader = false;
        state.designation = action.payload?.data;
      })
      .addCase(updateDesignation.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.payload;
      })

      .addCase(deleteDesignation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteDesignation.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteDesignation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetDesignationState } = designationSlice.actions;
export default designationSlice.reducer;
